import styles from './catalog-picker-modal.module.css'

import { RxInfoCircled } from '@react-icons/all-files/rx/RxInfoCircled'
import React from 'react'

import { Checkbox, Flex, Text } from 'components/ds'

import { CatalogInfoPopover } from '../catalog-info-popover'
import type { PickerCatalog } from './mock-catalogs'

export const CatalogAvatar = ({
  name,
  logoUrl,
}: {
  name: string
  logoUrl?: string
}) =>
  logoUrl ? (
    <img src={logoUrl} alt="" loading="lazy" className={styles.avatar} />
  ) : (
    <div aria-hidden="true" className={styles.avatar}>
      {name.charAt(0).toUpperCase()}
    </div>
  )

type CatalogListProps = {
  catalogs: PickerCatalog[]
  selectedIds: string[]
  onToggle: (id: string) => void
  emptyMessage?: string
}

export const CatalogList = ({
  catalogs,
  selectedIds,
  onToggle,
  emptyMessage = 'No catalogs match your search.',
}: CatalogListProps) => {
  if (catalogs.length === 0) {
    return (
      <Text size="2" color="gray" as="p" className={styles.empty}>
        {emptyMessage}
      </Text>
    )
  }

  return (
    <Flex direction="column" role="list">
      {catalogs.map((catalog, index) => (
        <Flex
          key={catalog.id}
          align="center"
          justify="between"
          gap="2"
          className={styles.row}
        >
          <Text as="label" size="2" className={styles.rowLabel}>
            <Flex align="center" gap="3">
              <Checkbox
                checked={selectedIds.includes(catalog.id)}
                onCheckedChange={() => onToggle(catalog.id)}
              />
              <CatalogAvatar name={catalog.name} logoUrl={catalog.logoUrl} />
              <Flex direction="column" className={styles.rowText}>
                <Text weight="medium" translate="no" truncate>
                  {catalog.name}
                </Text>
                <Text size="1" color="gray">
                  {catalog.trackCount.toLocaleString()} tracks
                </Text>
              </Flex>
            </Flex>
          </Text>
          {/* Same hover card as the /search Source column. */}
          <CatalogInfoPopover
            source={{
              id: index,
              name: catalog.name,
              description: catalog.description,
              track_count: catalog.trackCount,
              image_url: catalog.logoUrl,
              url: catalog.url,
            }}
          >
            <button
              type="button"
              className={styles.infoIcon}
              aria-label={`About ${catalog.name}`}
            >
              <RxInfoCircled />
            </button>
          </CatalogInfoPopover>
        </Flex>
      ))}
    </Flex>
  )
}
